export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-b5eec370ce43155fbde9db5b8b58e691.svg";